import { render } from "./ChatMessage.vue?vue&type=template&id=a35bf126"
import script from "./ChatMessage.vue?vue&type=script&lang=js"
export * from "./ChatMessage.vue?vue&type=script&lang=js"

import "./ChatMessage.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__